/**
 * Levi panel sa linkovima na h1–h3 unutar mainContentSelector.
 * Aktivira se prefs.toc; naslovima bez id dodeljuje ap-toc-heading-N.
 */

import React, { useEffect, useState } from 'react';

export default function TableOfContents({ active, mainContentSelector, classPrefix = 'ap', labels }) {
  const [headings, setHeadings] = useState([]);
  const [collapsed, setCollapsed] = useState(false);

  useEffect(() => {
    if (!active) {
      setHeadings([]);
      return undefined;
    }

    function scan() {
      const main = document.querySelector(mainContentSelector);
      if (!main) return;
      const nodes = main.querySelectorAll('h1, h2, h3');
      const items = [];
      nodes.forEach((node, i) => {
        if (!node.id) node.id = `${classPrefix}-toc-heading-${i}`;
        items.push({
          id: node.id,
          text: node.textContent.trim(),
          level: parseInt(node.tagName[1], 10),
        });
      });
      setHeadings(items);
    }

    scan();
    const main = document.querySelector(mainContentSelector);
    if (!main) return undefined;

    const observer = new MutationObserver(scan);
    observer.observe(main, { childList: true, subtree: true });
    return () => observer.disconnect();
  }, [active, mainContentSelector, classPrefix]);

  if (!active || headings.length === 0) return null;

  return (
    <nav
      className={`${classPrefix}-toc-panel${collapsed ? ` ${classPrefix}-toc-panel--collapsed` : ''}`}
      aria-label={labels.tocNav}
    >
      <button type="button" className={`${classPrefix}-toc-toggle`} onClick={() => setCollapsed((v) => !v)}>
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          <line x1="3" y1="6" x2="21" y2="6" /><line x1="3" y1="12" x2="21" y2="12" /><line x1="3" y1="18" x2="21" y2="18" />
        </svg>
        <span>{labels.tocToggle}</span>
        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" className={`${classPrefix}-toc-chevron`}>
          {collapsed
            ? <polyline points="6 9 12 15 18 9" />
            : <polyline points="18 15 12 9 6 15" />}
        </svg>
      </button>
      {!collapsed && (
        <ul className={`${classPrefix}-toc-list`}>
          {headings.map((h) => (
            <li key={h.id} className={`${classPrefix}-toc-item ${classPrefix}-toc-level-${h.level}`}>
              <a
                href={`#${h.id}`}
                onClick={() => document.getElementById(h.id)?.scrollIntoView({ behavior: 'smooth' })}
              >
                {h.text}
              </a>
            </li>
          ))}
        </ul>
      )}
    </nav>
  );
}
